if (!customElements.get('variant-selects')) {
    customElements.define('variant-selects', class VariantSelects extends HTMLElement {
        constructor() {
            super();
            this.addEventListener('change', this.onVariantChange);

            // Handle pill clicks since they might not trigger 'change' on the container automatically if not inputs
            this.querySelectorAll('.swatch-color, .swatch-size').forEach(pill => {
                const handleSelection = () => {
                    pill.parentElement.querySelectorAll('.active').forEach(a => {
                        a.classList.remove('active');
                        a.setAttribute('aria-pressed', 'false');
                    });
                    pill.classList.add('active');
                    pill.setAttribute('aria-pressed', 'true');

                    // Update option label display value
                    const valSpan = pill.parentElement.parentElement.querySelector('[data-header-option-value]');
                    if (valSpan) {
                        valSpan.textContent = pill.dataset.headerValue || pill.dataset.luxuryValue || pill.dataset.value;
                    }

                    this.onVariantChange();
                };

                pill.addEventListener('click', handleSelection);

                pill.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        handleSelection();
                    }
                });
            });

            this.detectCurrencySymbol();
            this.onVariantChange();
        }

        onVariantChange(event) {
            this.updateOptions();
            this.updateMasterId();
            this.toggleAddButton(true, '', false);
            this.updateVariantInput();
            this.renderProductInfo();
            this.updateAvailabilityStyling();
            this.updateHeaderLabels();
        }

        getVariantQuantities() {
            if (!this.variantQuantities) {
                const el = this.querySelector('script[id^="VariantQuantities-"]') || document.querySelector('script[id^="VariantQuantities-"]');
                if (el) {
                    try {
                        this.variantQuantities = JSON.parse(el.textContent);
                    } catch (e) {
                        this.variantQuantities = {};
                    }
                } else {
                    this.variantQuantities = {};
                }
            }
            return this.variantQuantities;
        }

        updateAvailabilityStyling() {
            if (!this.currentVariant) return;

            // Update availability block (Dynamic Scarcity < 10 & Stock Badge)
            const stockCheckmark = document.querySelector('.product-availability');
            if (stockCheckmark) {
                const isFr = (document.documentElement.lang || '').toLowerCase().startsWith('fr');
                const quantities = this.getVariantQuantities();
                const variantQtyInfo = quantities[this.currentVariant.id];
                const qty = variantQtyInfo && typeof variantQtyInfo.qty === 'number' ? variantQtyInfo.qty : (typeof this.currentVariant.inventory_quantity === 'number' ? this.currentVariant.inventory_quantity : 0);
                const isManaged = variantQtyInfo && variantQtyInfo.managed ? Boolean(variantQtyInfo.managed) : Boolean(this.currentVariant.inventory_management);

                if (this.currentVariant.available) {
                    if (isManaged && qty > 0 && qty < 10) {
                        stockCheckmark.className = 'product-availability low-stock';
                        stockCheckmark.style.cssText = 'color: #d97706; font-weight: 600; display: inline-flex; align-items: center; gap: 8px; font-size: 0.83rem; background: #fffbe8; border: 1px solid #fde68a; padding: 6px 12px; border-radius: 4px; margin-bottom: 8px;';
                        const dot = '<span style="display: inline-block; width: 8px; height: 8px; border-radius: 50%; background: #d97706; box-shadow: 0 0 6px rgba(217, 119, 6, 0.5);"></span>';
                        const text = isFr ? `⚡ Stock Limité — Plus que ${qty} unités disponibles` : `⚡ Low Stock — Only ${qty} units left in stock`;
                        stockCheckmark.innerHTML = `${dot}<span>${text}</span>`;
                    } else {
                        stockCheckmark.className = 'product-availability in-stock';
                        stockCheckmark.style.cssText = 'color: #059669; font-weight: 600; display: inline-flex; align-items: center; gap: 8px; font-size: 0.83rem; background: #ecfdf5; border: 1px solid #a7f3d0; padding: 6px 12px; border-radius: 4px; margin-bottom: 8px;';
                        const dot = '<span style="display: inline-block; width: 8px; height: 8px; border-radius: 50%; background: #10b981; box-shadow: 0 0 6px rgba(16, 185, 129, 0.5);"></span>';
                        const text = isFr ? `✓ En Stock — Prêt à l'Expédition Immédiate` : `✓ In Stock — Ready for Immediate Dispatch`;
                        stockCheckmark.innerHTML = `${dot}<span>${text}</span>`;
                    }
                } else {
                    stockCheckmark.className = 'product-availability out-stock';
                    stockCheckmark.style.cssText = 'color: #dc2626; font-weight: 600; display: inline-flex; align-items: center; gap: 8px; font-size: 0.83rem; background: #fef2f2; border: 1px solid #fecaca; padding: 6px 12px; border-radius: 4px; margin-bottom: 8px;';
                    const dot = '<span style="display: inline-block; width: 8px; height: 8px; border-radius: 50%; background: #ef4444;"></span>';
                    const text = isFr ? `Épuisé — Sur Liste d'Attente VIP` : `Sold Out — Join VIP Waitlist`;
                    stockCheckmark.innerHTML = `${dot}<span>${text}</span>`;
                }
            }

            // Update Restock Message under the button
            const restockMessage = document.querySelector('.restock-message');
            if (restockMessage) {
                if (this.currentVariant.available) {
                    restockMessage.style.display = 'none';
                } else {
                    restockMessage.style.display = 'block';
                }
            }
        }

        updateHeaderLabels() {
            // Sync [data-header-option-value] spans for all option containers
            // Works for both pill/swatch pickers and <select> dropdown pickers
            this.querySelectorAll('.product-form__input').forEach(container => {
                const valSpan = container.querySelector('[data-header-option-value]');
                if (!valSpan) return;

                const activePill = container.querySelector('.swatch-color.active, .swatch-size.active');
                if (activePill) {
                    valSpan.textContent = activePill.dataset.headerValue || activePill.dataset.luxuryValue || activePill.dataset.value || activePill.textContent.trim();
                    return;
                }

                const select = container.querySelector('select');
                if (select && select.selectedIndex >= 0) {
                    valSpan.textContent = select.options[select.selectedIndex].textContent.trim();
                }
            });
        }

        updateOptions() {
            // Logic to get selected options from pills/swatches
            const containers = Array.from(this.querySelectorAll('.product-form__input'));
            this.options = containers.map((container) => {
                const activePill = container.querySelector('.active');
                if (activePill) return activePill.dataset.value;
                const select = container.querySelector('select');
                if (select) return select.value;
                return null;
            });
        }

        updateMasterId() {
            this.currentVariant = this.getVariantData().find((variant) => {
                const results = variant.options.map((option, index) => {
                    return this.options[index] === option;
                });
                return !results.includes(false);
            });
        }

        updateVariantInput() {
            const productForms = document.querySelectorAll(`#ProductForm, #ProductForm-${this.dataset.section}`);
            productForms.forEach((productForm) => {
                const input = productForm.querySelector('input[name="id"]');
                input.value = this.currentVariant ? this.currentVariant.id : '';
                input.dispatchEvent(new Event('change', { bubbles: true }));
            });
        }

        renderProductInfo() {
            if (!this.currentVariant) {
                this.toggleAddButton(true, window.variantStrings.unavailable, true);
                return;
            }

            // Update Add Button State
            if (!this.currentVariant.available) {
                this.toggleAddButton(true, window.variantStrings.soldOut, true);
            } else {
                this.toggleAddButton(false, window.variantStrings.addToCart, true);
            }

            // Update Prices
            const salePriceElements = document.querySelectorAll('.price-item--sale, .price-current');
            salePriceElements.forEach(el => {
                el.textContent = this.formatMoney(this.currentVariant.price);
            });

            const regularPriceElements = document.querySelectorAll('.price-item--regular');
            const combinedBadges = document.querySelectorAll('.price__badge-combined');
            const hasSale = this.currentVariant.compare_at_price > this.currentVariant.price;

            let comparePriceHtml = '';
            let combinedBadgeHtml = '';

            if (hasSale) {
                comparePriceHtml = this.formatMoney(this.currentVariant.compare_at_price);
                const savedPercent = Math.round(((this.currentVariant.compare_at_price - this.currentVariant.price) * 100) / this.currentVariant.compare_at_price);
                const savedAmount = this.formatMoney(this.currentVariant.compare_at_price - this.currentVariant.price);
                combinedBadgeHtml = `${savedPercent}% off | Save ${savedAmount}`;
            }

            regularPriceElements.forEach(el => {
                if (hasSale) {
                    el.textContent = comparePriceHtml;
                    el.style.display = '';
                } else {
                    el.style.display = 'none';
                }
            });

            combinedBadges.forEach(el => {
                if (hasSale) {
                    el.textContent = combinedBadgeHtml;
                    el.style.display = '';
                } else {
                    el.style.display = 'none';
                }
            });

            // Update Subtotal in Quantity Label
            const subtotalElement = document.querySelector('.quantity-subtotal span');
            if (subtotalElement) {
                const qtyInput = document.querySelector('.qty-input');
                const qty = qtyInput ? parseInt(qtyInput.value) : 1;
                subtotalElement.textContent = `Subtotal: ${this.formatMoney(this.currentVariant.price * qty)}`;
            }

            // Update Gallery Media
            if (this.currentVariant.featured_media) {
                if (window.Theme && window.Theme.updateGalleryByMediaId) {
                    window.Theme.updateGalleryByMediaId(this.currentVariant.featured_media.id);
                } else {
                    // Fallback to image src replacement if Theme function isn't available
                    const mainImage = document.getElementById('MainImage');
                    if (mainImage && this.currentVariant.featured_image) {
                        mainImage.src = this.currentVariant.featured_image.src;
                    }
                }
            }

            // Update URL
            if (this.dataset.updateUrl !== 'false') {
                window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
            }
        }

        getVariantData() {
            this.variantData = this.variantData || JSON.parse(this.querySelector('script[type="application/json"]').textContent);
            return this.variantData;
        }

        toggleAddButton(disable = true, text, modifyClass = true) {
            const productForm = document.getElementById(`ProductForm-${this.dataset.section}`) || document.getElementById('ProductForm');
            if (!productForm) return;
            const addButton = productForm.querySelector('[name="add"]');
            const addButtonText = addButton.querySelector('span');

            if (!addButton) return;

            if (disable) {
                addButton.setAttribute('disabled', 'disabled');
                if (text) addButtonText.textContent = text;
            } else {
                addButton.removeAttribute('disabled');
                addButtonText.textContent = window.variantStrings.addToCart;
            }
        }

        detectCurrencySymbol() {
            const activeCurrency = window.Shopify?.currency?.active || 'CAD';
            const priceEl = document.querySelector('.price-item--sale, .price-current');
            if (priceEl) {
                const text = priceEl.textContent.trim();
                const cleaned = text.replace(/[0-9\s,.-]/g, '');
                const regex = new RegExp(activeCurrency, 'gi');
                const symbol = cleaned.replace(regex, '').trim();
                if (symbol) {
                    this.dataset.currencySymbol = symbol;
                    return;
                }
            }
            
            if (!this.dataset.currencySymbol) {
                let symbol = '$';
                if (activeCurrency === 'EUR') symbol = '€';
                else if (activeCurrency === 'GBP') symbol = '£';
                else if (activeCurrency === 'JPY') symbol = '¥';
                this.dataset.currencySymbol = symbol;
            }
        }

        formatMoney(cents) {
            const currency = window.Shopify?.currency?.active || 'CAD';
            const amount = cents / 100;
            const formattedAmount = Number.isInteger(amount) ? amount.toString() : amount.toFixed(2);
            
            let symbol = this.dataset.currencySymbol || '$';
            console.log("CRO: formatMoney active symbol:", symbol);
            
            const showIso = this.dataset.showIso !== 'false';
            if (currency === 'CAD') {
                return `${formattedAmount}$${showIso ? ' CAD' : ''}`;
            }
            
            if (showIso) {
                return `${symbol}${formattedAmount} ${currency}`;
            }
            return `${symbol}${formattedAmount}`;
        }
    });
}
